import { TIME_SELECT_DATA } from '@/shared/const';

export const getTimeOptions = () => {
    const now = new Date();
    const currentHour = now.getHours();

    return TIME_SELECT_DATA.map((item) => {
        const startHour = parseInt(item.label.split(':')[0]);

        return {
            ...item,
            disabled: currentHour >= startHour,
        };
    });
};
